module.exports = __webpack_public_path__ + "static/media/clydesdale-bank.76e37146.svg";